<sb-card [loading]="loading">
  <div card-header>
    <b>{{'lang.companyDetails.mediumGroupsHeadline' | translate}}</b>
    <small *ngIf="paginationInitialized">{{ paginationString }}</small>
  </div>
  <div card-header-more>
    <sb-button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top" container="body"
               classes="btn-default actionButtonMinWidth"
               (click)="requestDebounced()" [disabled]="loading" [loading]="loading">
      <sb-icon icon="refresh"></sb-icon>
    </sb-button>
    <a *ngPermissions="permissionService.Permission.medium_group_list"
       [sbRouterLink]="util.RoutingID.mediumGroup" [queryParams]="{'company': companyId}">
      <button class="btn btn-primary">{{'lang.globals.showInList' | translate}}</button>
    </a>
  </div>
  <div card-body>
    <sb-comp-embedded-medium-groups *ngIf="mediumGroups" [mediumGroups]="mediumGroups"></sb-comp-embedded-medium-groups>
    <div style="padding: 20px 1.25rem;" sb-pagination *ngIf="paginationInitialized" [collectionSize]="collectionSize"
         [(page)]="page"
         (pageChange)="pageChange($event)" [maxSize]="maxSize" [boundaryLinks]="boundaryLinks">
      {{paginationString}}
    </div>
  </div>
</sb-card>
